import React, { createContext, useContext, useState } from 'react';
import useRealtimeChat from 'src/hooks/useRealtimeChat';
import { IConfigByCountry, IMessage } from 'src/lib/schemas';

interface RealtimeChatContextType {
	isConnected: boolean;
	isMyAssistantWritting: boolean;
	messages: IMessage[];
	sendMessage: (text: string) => void;
	countryConfig: IConfigByCountry | null;
	isLoading: boolean;
	setIsLoading: React.Dispatch<React.SetStateAction<boolean>>;
	startNewConversation: () => void;
	isWaitingForMessage: boolean;
}

export const RealtimeChatContext = createContext<RealtimeChatContextType>(
	{} as RealtimeChatContextType,
);

interface RealtimeChatProviderProps {
	assistantAlias: string;
	initialMessage: string;
	countryCode: string;
	children: React.ReactNode;
}

export const RealtimeChatProvider: React.FC<RealtimeChatProviderProps> = ({
	assistantAlias,
	initialMessage,
	countryCode,
	children,
}) => {
	const {
		isConnected,
		isMyAssistantWritting,
		messages,
		sendMessage,
		countryConfig,
		isLoading,
		setIsLoading,
		startNewConversation,
		isWaitingForMessage,
	} = useRealtimeChat(assistantAlias, initialMessage, countryCode);

	return (
		<RealtimeChatContext.Provider
			value={{
				isConnected,
				isMyAssistantWritting,
				messages,
				sendMessage,
				countryConfig,
				isLoading,
				setIsLoading,
				startNewConversation,
				isWaitingForMessage,
			}}
		>
			{children}
		</RealtimeChatContext.Provider>
	);
};

export function useRealtimeChatContext() {
	return useContext(RealtimeChatContext);
}
